import httpService from "../../components/service";

export const component = {
    namespaced: true,
    state: {
        component: {}
    },
    getters: {
        getComponent: state => {
            return state.component;
        }
    },
    mutations: {
        SET_COMPONENT(state, res) {
            state.component = Object.values(res);
        }
    },
    actions: {
        async getComponentAction(context, objSearch) {
            const res = await httpService.get("/components_all_types?search=" + objSearch);
            context.commit("SET_COMPONENT", res);
            return res;
        }
    }
};



// WEBPACK FOOTER //
// ./src/store/search/component.js